﻿const validators = {
	postalCodeResponse: function (data) {
		if (!data || typeof data !== 'object') return false;
		if (typeof data.postal_code !== 'string') return false;
		if (data.postal_code.length !== 5) return false;

		return true;
	},

	shopsResponse: function (data) {
		if (!data || typeof data !== 'object') return false;
		if (!data.hasOwnProperty('shops') || !Array.isArray(data.shops)) return false;
		if (data.shops.length !== 0) {
			const firstShop = data.shops[0];
			if (!firstShop.hasOwnProperty('id') || typeof firstShop.id !== 'string') return false;
		}

		return true;
	},
	
	searchResponse: function (data) {
		if (!data || typeof data !== 'object') return false;
		if (!data.hasOwnProperty('products') || !Array.isArray(data.products)) return false;
		if (data.products.length !== 0) {
			data.products.forEach(product => {
				if (!product.hasOwnProperty('id') || typeof product.id !== 'string') return false;
			})
		}

		return true;
	},

	productResponse: function (data) {
		if (!data || typeof data !== 'object') return false;
		if (!data.hasOwnProperty('products') || !Array.isArray(data.products)) return false;
		if (data.products.length !== 0) {
			data.products.forEach(product => {
				if (!product.hasOwnProperty('id') || typeof product.id !== 'string') return false;
				if (!product.hasOwnProperty('name') || typeof product.name !== 'string') return false;
				if (!product.hasOwnProperty('image_url') || typeof product.price !== 'string') return false;
				if (!product.hasOwnProperty('permalink_url') || typeof product.price !== 'string') return false;
				if (!product.hasOwnProperty('shop_level_attributes') || !Array.isArray(product.shop_level_attributes)) return false;
				if (product.shop_level_attributes.length !== 0) {
					let attrs = product.shop_level_attributes;
					if (!attrs.hasOwnProperty('quantity_attributes') || !Array.isArray(attrs.quantity_attributes)) return false;
					if (!attrs.hasOwnProperty('availability') || typeof attrs.availability !== 'string') return false;
				}
			})
		}

		return true;
	},
	
	cartIdResponse: function (data) {
		if (!data || typeof data !== 'object') return false;
		if (!data.hasOwnProperty('carts') || !Array.isArray(data.carts)) return false;
		if (data.carts.length !== 0) {
			data.carts.forEach(cart => {
				if (!cart.hasOwnProperty('id') || typeof cart.id !== 'string') return false;
			})
		}
		
		return true;
	},
	
	cartItemsResponse: function (data) {
		if (!data || typeof data !== 'object') return false;
		if (!data.hasOwnProperty('items') || !Array.isArray(data.items)) return false;
		if (data.items.length !== 0) {
			data.items.forEach(item => {
				if (!item.hasOwnProperty('product_id') || typeof item.product_id !== 'string') return false;
				if (!item.hasOwnProperty('quantity') || typeof item.quantity !== 'string') return false;
				if (!item.hasOwnProperty('quantity_type') || typeof item.quantity_type !== 'string') return false;
			})
		}
		
		return true;
	},
};

function validateApiResponse(data, responseType)
{
	const validator = validators[responseType];

	if (!validator) {
		throw new Error(`No validator defined for response type: ${responseType}`);
	}

	if (!validator(data)) {
		throw new Error(`Invalid ${responseType} format`);
	}

	return data;
}

export {
	validateApiResponse
};
